export const removeHtmlCode = (string) => {
  return typeof string === 'string' ? string.replace(/(<([^>]+)>)/ig, '') : string;
}



// WEBPACK FOOTER //
// ./src/shared/mixin.js